import { IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import '@wangeditor/editor/dist/css/style.css'; // 引入 css
import { Button, Col, Form, Input, Row, Switch, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../../config/apiUrl';
import '../../static/css/AddArticle.css';
function AddNotice(props) {

    const [hideSW, setHideSW] = useState(false);
    const [fields, setFields] = useState([]);
    const [adId, setAdId] = useState(props.match.params.id)  // 文章的ID，如果是0说明是新增加，如果不是0，说明是修改
    const [adTitle, setAdTitle] = useState('')   //文章标题

    // editor 实例
    const [editor, setEditor] = useState(null)   // TS 语法

    // 编辑器内容
    const [richTextContent, setRichTextContent] = useState('<dvi> </dvi>')

    useEffect(() => {
        setAdId(props.match.params.id)
        if (props.match.params.id) {
            getAdInfo()
        }
    }, [props.match.params.id])


    // 工具栏配置
    const toolbarConfig: Partial<IToolbarConfig> = {}

    // 编辑器配置
    const editorConfig: Partial<IEditorConfig> = {
        placeholder: '请输入内容...',
        MENU_CONF: {}

    }
    editorConfig.MENU_CONF['uploadImage'] = {
        server: servicePath.serverUrl + '/admin/uploadImage',
    }

    // 及时销毁 editor ，重要！
    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor])

    //获取编辑公告的默认数据
    const getAdInfo = () => {
        const hide = message.loading('...', 0);
        axios({
            method: 'get',
            url: servicePath.getNoticeInfo + "/" + adId,
            // withCredentials: true,
            // header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                setTimeout(hide, 100);
                if (res.data.code == 1) {

                    let resData = res.data?.data || {}
                    setHideSW(resData.hide == 1 ? 0 : 1)
                    setRichTextContent(resData.rich_text_content)
                    setAdId(resData.adId)
                    setFields([

                        {
                            name: ['user', 'adTitle'],
                            value: resData.title,
                        },
                    ])

                } else {
                    console.log("未查到相关公告数据:", res.data)
                }


            }
        )

    }

    const validateMessages = {
        required: '${label} 必须填写!',
        types: {
            email: '${label} is not validate email!',
            number: '${label} is not a validate number!',
        },
        number: {
            range: '${label} must be between ${min} and ${max}',
        },
    };

    const onFinish = values => {
        const key = 'addData';
        let fromData = values.user;
        if (!fromData.adTitle) {
            message.error('标题不能为空')
            return false
        } else if (!richTextContent) {
            message.error('公告页面详情内容')
            return false
        }

        var formData = new FormData();
        formData.append("title", fromData.adTitle);
        formData.append("hide", hideSW ? 0 : 1);
        console.log("fromData.hide:", fromData)
        formData.append("rich_text_content", richTextContent);
        // 保存
        let url = servicePath.addNoticeInfo
        let msg = '添加公告信息成功！'
        let errMsg = '添加公告信息失败！'

        if (adId) {

            // 修改公告内容
            formData.append("adId", adId);
            url = servicePath.editNoticeInfo
            msg = '修改公告信息成功！'
            errMsg = '修改公告信息失败！'

        }
        message.loading({ content: '保存数据...' });
        axios({
            method: 'POST',
            url: url,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(
            res => {
                if (res.data.code == 1) {
                    message.success({ content: msg, key, duration: 2 });
                    setTimeout(() => {
                        props.history.push('/notice/list')
                    }, 2000)
                } else {
                    message.error({ content: errMsg, key, duration: 2 });
                }


            }
        ).catch((res) => {
            message.error({ content: '添加公告失败！', key, duration: 2 });
        })
    };


    const layout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 15 },
    };

    const clSwitch = (checked, event) => {
        setHideSW(!hideSW)
    }
    return (
        <>
            <Form {...layout} name="nest-messages" fields={fields} onFinish={onFinish} method="post" enctype="multipart/form-data" validateMessages={validateMessages}>
                <div>
                    <Row gutter={12}>
                        <Col span={20}>
                            {adId && <Form.Item name={['user', 'adId']} label="公告Id" >
                                <Input defaultValue={adId} maxLength='10' disabled={1} />
                            </Form.Item>}
                            <Form.Item name={['user', 'adTitle']} label="标题" rules={[{ required: true, message: '必填' }]}>
                                <Input defaultValue={adTitle} />
                            </Form.Item>

                            <Form.Item name={['user', 'hide']} label="是否显示" >
                                <Switch checked={hideSW} onClick={() => { clSwitch() }} />
                            </Form.Item>
                            <Form.Item label="公告页面详情内容" >
                                <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
                                    <Toolbar
                                        editor={editor}
                                        defaultConfig={toolbarConfig}
                                        mode="default"
                                        style={{ borderBottom: '1px solid #ccc' }}
                                    />
                                    <Editor
                                        defaultConfig={editorConfig}
                                        value={richTextContent}
                                        onCreated={setEditor}
                                        onChange={editor => setRichTextContent(editor.getHtml())}
                                        mode="default"
                                        style={{ height: '500px', overflowY: 'hidden' }}
                                    />
                                </div>
                            </Form.Item>

                        </Col>

                        <Col span={4}>
                            <Row>
                                <Col span={24}>
                                    {adId && <Button type="primary" size="large" htmlType="submit">修改公告信息</Button>}
                                    {!adId && <Button type="primary" size="large" htmlType="submit" >发布公告</Button>}
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </div>
            </Form>
        </>
    )
}
export default AddNotice